<template>
  <select
      :id=name
      :name=name
      class="form-control"
      v-model="selected"
      :disabled="disabled"
      @change="updateInput"
  >
    <option v-for="opt in computedOptions" :value="opt.value" :key="opt.value">
      {{ opt.label }}
    </option>
  </select>
</template>

<script>
import {forEach} from "underscore";

export default {
  props: ['initialOptions','name','disabled','selectValue','defaultValue'],
  watch: {
    selectValue: function(newVal, oldVal) { // watch it
      if(newVal === '') this.selected = ''
    }
  },
  data() {
    return {
      selectDefault: '--Select One--',
      selected: this.selectValue,
    }
  },
  computed: {
    computedOptions() {
      let options = []
      options.push({label: this.selectDefault, value: ''})
      forEach(this.initialOptions, (val) => {
        options.push({label: val.label, value: val.value})
      })
      return options
    }
  },
  methods: {
    updateInput() {
      this.$emit('input',this.selected)
    }
  }
}
</script>